/* =========================================================
   HONEY HOUR v2 · Theme JS
   ========================================================= */
(function() {
  'use strict';
  const qs  = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => Array.from(c.querySelectorAll(s));
  const onReady = (fn) => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  // --- Reveal-on-scroll ---
  const initReveal = () => {
    const els = qsa('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(el => el.classList.add('visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('visible'), i * 60);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => io.observe(el));
  };

  // --- Countdown ---
  const initCountdown = () => {
    const el = qs('[data-countdown]');
    if (!el) return;
    const KEY = 'hh_flash_end';
    const FOUR_HOURS = 4 * 60 * 60 * 1000;
    let end = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + FOUR_HOURS; localStorage.setItem(KEY, end.toString()); }
    const hh = qs('[data-cd-hh]', el), mm = qs('[data-cd-mm]', el), ss = qs('[data-cd-ss]', el);
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (hh) hh.textContent = String(h).padStart(2, '0');
      if (mm) mm.textContent = String(m).padStart(2, '0');
      if (ss) ss.textContent = String(s).padStart(2, '0');
      if (diff <= 0) { end = Date.now() + FOUR_HOURS; localStorage.setItem(KEY, end.toString()); }
    };
    tick(); setInterval(tick, 1000);
  };

  // --- Before / After slider ---
  const initBeforeAfter = () => {
    qsa('[data-ba]').forEach(root => {
      const after = qs('[data-ba-after]', root), handle = qs('[data-ba-handle]', root);
      if (!after || !handle) return;
      const setPos = (pct) => {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
        handle.style.left = pct + '%';
      };
      setPos(50);
      let drag = false;
      const x = (e) => {
        const r = root.getBoundingClientRect();
        const cx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        return (cx / r.width) * 100;
      };
      root.addEventListener('mousedown', (e) => { drag = true; setPos(x(e)); e.preventDefault(); });
      root.addEventListener('touchstart', (e) => { drag = true; setPos(x(e)); }, { passive: true });
      window.addEventListener('mousemove', (e) => { if (drag) setPos(x(e)); });
      window.addEventListener('touchmove', (e) => { if (drag) setPos(x(e)); }, { passive: true });
      window.addEventListener('mouseup', () => drag = false);
      window.addEventListener('touchend', () => drag = false);
    });
  };

  // --- Quiz (plants + organization) ---
  const initQuiz = () => {
    const quiz = qs('[data-quiz]');
    if (!quiz) return;
    const questions = [
      { q: "What are you trying to figure out first?", options: ['Plants for my space', 'Organization for my stuff', 'Both — I want it all'] },
      { q: "How would you describe your space?", options: ['Small apartment / dorm', 'Medium home', 'Big space, lots of corners'] },
      { q: "Your vibe?", options: ['Minimal & calm', 'Cozy & layered', 'Lush & full'] }
    ];
    const bundles = [
      { title: 'The Starter Set', desc: 'Easy-care seeds for small spaces & busy beginners — basil, radishes, lettuce, cherry tomatoes.', url: '/collections/the-starter-set' },
      { title: 'The Layered Set', desc: 'Mid-difficulty mix — Roma tomatoes, cucumbers, and a long-blooming zinnia. For the gardener who\'s done a season or two.', url: '/collections/the-layered-set' },
      { title: 'The Full Sanctuary', desc: 'Premium heirloom showstoppers — the lush, abundant garden for homes that go all in.', url: '/collections/the-full-sanctuary' }
    ];
    let step = 0; const answers = [];
    const progress = qsa('[data-quiz-progress] span', quiz);
    const stage = qs('[data-quiz-stage]', quiz);
    const result = qs('[data-quiz-result]', quiz);
    const resultTitle = qs('[data-quiz-result-title]', quiz);
    const resultDesc = qs('[data-quiz-result-desc]', quiz);
    const render = () => {
      const cur = questions[step];
      progress.forEach((p, i) => p.classList.toggle('active', i <= step));
      stage.innerHTML = `
        <h3 class="quiz-question">${cur.q}</h3>
        <div class="quiz-options">
          ${cur.options.map((opt, i) => `<button class="quiz-option" data-quiz-pick="${i}">${opt}</button>`).join('')}
        </div>`;
      qsa('[data-quiz-pick]', stage).forEach(btn => {
        btn.addEventListener('click', () => {
          answers.push(parseInt(btn.dataset.quizPick, 10));
          step++;
          if (step < questions.length) render();
          else {
            const avg = Math.round(answers.reduce((a,b)=>a+b,0) / answers.length);
            const pick = bundles[Math.min(avg, bundles.length - 1)];
            stage.style.display = 'none';
            qs('[data-quiz-progress]', quiz).style.display = 'none';
            resultTitle.textContent = pick.title;
            resultDesc.textContent = pick.desc;
            const cta = qs('.quiz-result__bundle a', quiz);
            if (cta && pick.url) cta.href = pick.url;
            result.classList.add('active');
          }
        });
      });
    };
    render();
  };

  // --- Live Heat FOMO ---
  const initLiveHeat = () => {
    const el = qs('[data-live-heat]');
    if (!el) return;
    const close = qs('[data-live-heat-close]', el);
    const cityEl = qs('[data-live-heat-city]', el);
    const countEl = qs('[data-live-heat-count]', el);
    const cities = ['Brooklyn', 'Austin', 'Portland', 'Denver', 'Seattle', 'Asheville', 'Nashville', 'Boulder', 'Berkeley', 'Savannah'];
    if (sessionStorage.getItem('hh_heat_dismissed') === '1') return;
    const showOne = () => {
      const city = cities[Math.floor(Math.random() * cities.length)];
      const count = 2 + Math.floor(Math.random() * 6);
      if (cityEl) cityEl.textContent = city;
      if (countEl) countEl.textContent = count;
      el.classList.add('visible');
      setTimeout(() => el.classList.remove('visible'), 6000);
    };
    setTimeout(showOne, 4500); setInterval(showOne, 24000);
    if (close) close.addEventListener('click', () => { sessionStorage.setItem('hh_heat_dismissed', '1'); el.classList.remove('visible'); });
  };

  // --- Sticky Cart ---
  const initStickyCart = () => {
    const bar = qs('[data-sticky-cart]');
    if (!bar) return;
    const trigger = qs('[data-sticky-trigger]') || qs('.product-info__price');
    if (!trigger) return;
    const io = new IntersectionObserver(([entry]) => { bar.classList.toggle('visible', !entry.isIntersecting); }, { threshold: 0 });
    io.observe(trigger);
  };

  // --- Bundle Suggest ---
  const initBundleSuggest = () => {
    const popup = qs('[data-bundle-suggest]');
    if (!popup) return;
    const close = qs('[data-bundle-close]', popup);
    qsa('form[action*="/cart/add"]').forEach(form => { form.addEventListener('submit', () => { setTimeout(() => popup.classList.add('visible'), 1200); }); });
    if (close) close.addEventListener('click', () => popup.classList.remove('visible'));
  };

  // --- Stock Bars ---
  const initStockBars = () => {
    qsa('[data-stock-bar]').forEach(bar => {
      const fill = qs('.stock-bar__fill', bar);
      const pct = parseFloat(bar.dataset.stockBar) || 0;
      if (fill) { fill.style.width = pct + '%'; if (pct < 20) fill.classList.add('stock-bar__fill--urgent'); }
    });
  };

  // === NEW 1 · CARE CARD FLIP ===
  const initCareCards = () => {
    qsa('[data-flip]').forEach(btn => {
      btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); const card = btn.closest('.product-card'); if (card) card.classList.toggle('flipped'); });
    });
    qsa('[data-flip-back]').forEach(btn => {
      btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); const card = btn.closest('.product-card'); if (card) card.classList.remove('flipped'); });
    });
  };

  // === NEW 2 · SUNLIGHT MATCH ===
  const initSunlight = () => {
    const root = qs('[data-sunlight]');
    if (!root) return;
    const sun = qs('[data-sun]', root);
    const result = qs('[data-sun-result]', root);
    const resultLabel = qs('[data-sun-label]', root);
    const buttons = qsa('[data-orientation]', root);
    const positions = {
      N: { x: 50, y: 75, label: 'low light · north-facing', copy: 'Best for low-light plants — snake plant, ZZ, pothos. Pair with our matte ceramics & rattan baskets.' },
      E: { x: 18, y: 25, label: 'morning light · east-facing', copy: 'Soft, gentle light all morning. Most plants thrive — try the linen hanger and a leafy fern.' },
      S: { x: 50, y: 10, label: 'full sun · south-facing', copy: 'Bright direct light. Succulents, citrus, herbs — our terracotta line drinks this up.' },
      W: { x: 82, y: 25, label: 'afternoon light · west-facing', copy: 'Warm afternoon sun. Hardy tropicals love it — monstera, fiddle leaf, palms.' }
    };
    const apply = (key) => {
      const p = positions[key]; if (!p || !sun) return;
      sun.style.left = `calc(${p.x}% - 20px)`;
      sun.style.top = `${p.y}%`;
      if (resultLabel) resultLabel.textContent = p.label;
      if (result) result.textContent = p.copy;
      buttons.forEach(b => b.classList.toggle('active', b.dataset.orientation === key));
    };
    buttons.forEach(btn => btn.addEventListener('click', () => apply(btn.dataset.orientation)));
    apply('S');
  };

  // === NEW 3 · SCALE CHECK ===
  const initScaleCheck = () => {
    qsa('[data-scale]').forEach(root => {
      const stage = qs('.scale-stage', root);
      const btns = qsa('[data-scale-ref]', root);
      const dim = qs('[data-scale-dim]', root);
      const dims = {
        cup: 'next to an 8-oz mug',
        hand: 'next to an adult hand',
        book: 'next to a paperback book',
        table: 'next to a side table'
      };
      const apply = (key) => {
        if (!stage) return;
        stage.classList.remove('scale-stage--cup','scale-stage--hand','scale-stage--book','scale-stage--table');
        stage.classList.add('scale-stage--' + key);
        if (dim) dim.textContent = dims[key] || '';
        btns.forEach(b => b.classList.toggle('active', b.dataset.scaleRef === key));
      };
      btns.forEach(b => b.addEventListener('click', () => apply(b.dataset.scaleRef)));
      apply('cup');
    });
  };

  // === NEW 4 · ROOM VIBE BUILDER ===
  const initRoomBuilder = () => {
    const root = qs('[data-room-builder]');
    if (!root) return;
    const stage = qs('[data-room-stage]', root);
    const placedLayer = qs('[data-room-placed]', stage);
    const shop = qs('[data-room-shop]', root);
    const totalEl = qs('[data-room-total]', root);
    const countEl = qs('[data-room-count]', root);
    const discountEl = qs('[data-room-discount]', root);
    const ctaEl = qs('[data-room-cta]', root);
    let placed = [];
    const KEY = 'hh_room_layout';
    try { const saved = JSON.parse(localStorage.getItem(KEY) || '[]'); if (Array.isArray(saved)) placed = saved.slice(0, 8); } catch (e) {}
    const save = () => { try { localStorage.setItem(KEY, JSON.stringify(placed)); } catch (e) {} };
    const renderPlaced = () => {
      if (!placedLayer) return;
      placedLayer.innerHTML = '';
      placed.forEach((item, idx) => {
        const div = document.createElement('div');
        div.className = 'room-stage__placed-item room-stage__placed-item--' + (item.color || 'moss');
        div.style.left = item.x + '%';
        div.style.top = item.y + '%';
        div.dataset.idx = idx;
        const inner = item.image ? `<img src="${item.image}" alt="${item.name}">` : `<div class="placed-swatch">${item.name}</div>`;
        div.innerHTML = `${inner}<button class="room-stage__placed-item__remove" aria-label="Remove" data-remove="${idx}">×</button>`;
        placedLayer.appendChild(div);
        let dragOff = null;
        const onDown = (e) => {
          if (e.target.matches('[data-remove]')) return;
          const rect = stage.getBoundingClientRect();
          const itemRect = div.getBoundingClientRect();
          const px = e.touches ? e.touches[0].clientX : e.clientX;
          const py = e.touches ? e.touches[0].clientY : e.clientY;
          dragOff = { dx: px - itemRect.left, dy: py - itemRect.top, sw: rect.width, sh: rect.height, sl: rect.left, st: rect.top };
          e.preventDefault();
        };
        const onMove = (e) => {
          if (!dragOff) return;
          const px = e.touches ? e.touches[0].clientX : e.clientX;
          const py = e.touches ? e.touches[0].clientY : e.clientY;
          let x = ((px - dragOff.sl - dragOff.dx) / dragOff.sw) * 100;
          let y = ((py - dragOff.st - dragOff.dy) / dragOff.sh) * 100;
          x = Math.max(0, Math.min(85, x)); y = Math.max(0, Math.min(82, y));
          item.x = x; item.y = y;
          div.style.left = x + '%'; div.style.top = y + '%';
        };
        const onUp = () => { if (dragOff) { dragOff = null; save(); } };
        div.addEventListener('mousedown', onDown);
        div.addEventListener('touchstart', onDown, { passive: false });
        window.addEventListener('mousemove', onMove);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('mouseup', onUp);
        window.addEventListener('touchend', onUp);
      });
      stage.classList.toggle('has-items', placed.length > 0);
      updateSummary();
    };
    const updateSummary = () => {
      const count = placed.length;
      const subtotal = placed.reduce((a, i) => a + (parseFloat(i.price) || 0), 0);
      const eligible = count >= 3;
      const total = eligible ? subtotal * 0.85 : subtotal;
      if (countEl) countEl.textContent = count;
      if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
      if (discountEl) discountEl.classList.toggle('active', eligible);
      if (ctaEl) { ctaEl.disabled = count === 0; ctaEl.style.opacity = count === 0 ? '0.5' : '1'; }
    };
    qsa('[data-shop-item]', shop).forEach((shopBtn, i) => {
      shopBtn.addEventListener('click', () => {
        if (placed.length >= 8) return;
        placed.push({
          id: shopBtn.dataset.id || ('demo-' + i),
          name: shopBtn.dataset.name || 'Item',
          price: shopBtn.dataset.price || 38,
          variantId: shopBtn.dataset.variantId || '',
          color: shopBtn.dataset.color || 'moss',
          image: shopBtn.dataset.image || '',
          x: 20 + Math.random() * 50, y: 20 + Math.random() * 50
        });
        save(); renderPlaced();
      });
    });
    if (placedLayer) {
      placedLayer.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-remove]');
        if (!btn) return;
        placed.splice(parseInt(btn.dataset.remove, 10), 1);
        save(); renderPlaced();
      });
    }
    if (ctaEl) {
      ctaEl.addEventListener('click', () => {
        if (!placed.length) return;
        const itemsWithVariant = placed.filter(i => i.variantId);
        if (itemsWithVariant.length) {
          const formData = new FormData();
          itemsWithVariant.forEach(i => { formData.append('items[][id]', i.variantId); formData.append('items[][quantity]', '1'); });
          fetch('/cart/add.js', { method: 'POST', body: formData }).then(() => { window.location.href = '/cart'; }).catch(() => { window.location.href = '/cart'; });
        } else { window.location.href = '/cart'; }
      });
    }
    renderPlaced();
  };

  // === NEW 5 · LIVING JOURNAL ===
  const initJournal = () => {
    qsa('[data-journal-add]').forEach(btn => {
      const productId = btn.dataset.journalAdd;
      const KEY = 'hh_journal';
      let journal = [];
      try { journal = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
      const isSaved = journal.some(j => j.id === productId);
      if (isSaved) { btn.classList.add('saved'); btn.textContent = 'In journal ✓'; }
      btn.addEventListener('click', () => {
        try { journal = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { journal = []; }
        const existing = journal.findIndex(j => j.id === productId);
        if (existing >= 0) {
          journal.splice(existing, 1);
          btn.classList.remove('saved');
          btn.textContent = btn.dataset.label || 'save to journal';
        } else {
          journal.push({ id: productId, title: btn.dataset.title || '', price: btn.dataset.price || '', url: btn.dataset.url || window.location.pathname, date: new Date().toISOString().slice(0,10) });
          btn.classList.add('saved');
          btn.textContent = 'In journal ✓';
        }
        localStorage.setItem(KEY, JSON.stringify(journal));
      });
    });
  };

  onReady(() => {
    initReveal(); initCountdown(); initBeforeAfter(); initQuiz();
    initLiveHeat(); initStickyCart(); initBundleSuggest(); initStockBars();
    initCareCards(); initSunlight(); initScaleCheck(); initRoomBuilder(); initJournal();
  });
})();

/* ========== v4 · Mobile menu + sticky header scroll behavior ========== */
(function() {
  const qs = (s, c) => (c || document).querySelector(s);
  const qsa = (s, c) => Array.from((c || document).querySelectorAll(s));
  const onReady = (fn) => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  onReady(() => {
    // Hamburger toggle
    const hamburger = qs('[data-hamburger]');
    const menu = qs('[data-mobile-menu]');
    if (hamburger && menu) {
      const open = () => {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };
      hamburger.addEventListener('click', () => {
        menu.classList.contains('is-open') ? close() : open();
      });
      qsa('[data-mobile-menu-close]', menu).forEach(el => el.addEventListener('click', close));
      // Close when a menu link is tapped
      qsa('a', menu).forEach(a => a.addEventListener('click', close));
      // Esc to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
      });
    }

    // Sticky header scroll-shadow
    const header = qs('[data-site-header]');
    if (header) {
      const onScroll = () => {
        if (window.scrollY > 16) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Bundle section — toggle selection + update total
    qsa('[data-product-bundle]').forEach(root => {
      const items = qsa('[data-bundle-item]', root);
      const totalEl = qs('[data-bundle-total]', root);
      const strikeEl = qs('[data-bundle-strike]', root);
      const countEl = qs('[data-bundle-count]', root);
      const cta = qs('[data-bundle-cta]', root);
      const update = () => {
        let subtotal = 0, count = 0, variantIds = [];
        items.forEach(item => {
          if (item.classList.contains('selected')) {
            subtotal += parseFloat(item.dataset.price) || 0;
            count++;
            if (item.dataset.variantId) variantIds.push(item.dataset.variantId);
          }
        });
        const eligible = count >= 3;
        const final = eligible ? subtotal * 0.85 : subtotal;
        if (countEl) countEl.textContent = count;
        if (totalEl) totalEl.textContent = '$' + final.toFixed(2);
        if (strikeEl) {
          if (eligible) { strikeEl.textContent = '$' + subtotal.toFixed(2); strikeEl.style.display = 'inline'; }
          else strikeEl.style.display = 'none';
        }
        if (cta) {
          cta.dataset.variantIds = variantIds.join(',');
          cta.disabled = count === 0;
          cta.textContent = count === 0
            ? 'pick at least one item ↑'
            : (eligible ? `add bundle · save 15% (${count} items)` : `add ${count} item${count>1?'s':''} to cart`);
        }
      };
      items.forEach(item => item.addEventListener('click', (e) => {
        e.preventDefault();
        item.classList.toggle('selected');
        update();
      }));
      if (cta) {
        cta.addEventListener('click', () => {
          const ids = (cta.dataset.variantIds || '').split(',').filter(Boolean);
          if (!ids.length) return;
          const formData = new FormData();
          ids.forEach(id => { formData.append('items[][id]', id); formData.append('items[][quantity]', '1'); });
          fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(() => { window.location.href = '/cart' + (ids.length >= 3 ? '?discount=BUNDLE15' : ''); })
            .catch(() => { window.location.href = '/cart'; });
        });
      }
      update();
    });
  });
})();
